import React from "react";
import DisplayComponent from "./DisplayComponent";
import { Attempt, EligibleRecord } from "types";
import { formatLongEligibleRecord } from "util/records";
import { useRecordAttempts } from "util/useRecordAttempts";
import { WidgetId, useDisplaySettings } from "./DisplaySettingsProvider";
import range from "lodash/range";

const editData: EligibleRecord = {
  location: "W",
  competitionType: "FP",
  gender: "MALE",
  divisionCode: "M1",
  weightClass: "63kg",
  equipmentLevel: "RAW",
  tested: "T",
  lift: "S",
};

export const getManuallySetRecord = (
  currentAttempt: Attempt | null | undefined,
) => {
  if (currentAttempt?.worldRecord) {
    return "World Record Attempt";
  } else if (currentAttempt?.regionalRecord) {
    return "Regional Record Attempt";
  } else if (currentAttempt?.stateRecord && currentAttempt?.americanRecord) {
    return "State and American Record Attempt";
  } else if (currentAttempt?.stateRecord && currentAttempt?.nationalRecord) {
    return "State and National Record Attempt";
  } else if (currentAttempt?.stateRecord) {
    return "State Record Attempt";
  } else if (currentAttempt?.americanRecord) {
    return "American Record Attempt";
  } else if (
    currentAttempt?.provincialRecord &&
    currentAttempt?.canadianRecord
  ) {
    return "Canadian and Provincial Record Attempt";
  } else if (currentAttempt?.canadianRecord) {
    return "Canadian Record Attempt";
  } else if (
    currentAttempt?.nationalRecord &&
    currentAttempt?.provincialRecord
  ) {
    return "Provincial and National Record Attempt";
  } else if (currentAttempt?.provincialRecord) {
    return "Provincial Record Attempt";
  } else if (currentAttempt?.nationalRecord) {
    return "National Record Attempt";
  }
};

const RecordInfo = ({
  currentAttempt,
  id,
}: {
  currentAttempt: Attempt | undefined | null;
  id: WidgetId;
}) => {
  const { state } = useDisplaySettings();
  const maxRecordsToShow = state.r.mr ?? 1;
  const { editMode } = useDisplaySettings();
  const allRecords = useRecordAttempts();

  const manualRecord = getManuallySetRecord(currentAttempt);

  const recordsForAttempt = currentAttempt
    ? allRecords?.[currentAttempt._id]
    : [];

  return (
    <DisplayComponent style={{ top: 138, left: 0 }} id={id}>
      {({ sizeMultiplier }: { sizeMultiplier: number }) => {
        const style = {
          fontSize: sizeMultiplier * 22,
          width: sizeMultiplier * 600,
        };

        if (editMode) {
          return (
            <div style={style} className="lifter-details">
              {manualRecord}
              {range(maxRecordsToShow).map((i) => {
                const recordText = formatLongEligibleRecord({
                  record: editData,
                });

                return (
                  <div key={`${i} ${recordText}`}>RECORD: {recordText}</div>
                );
              })}
            </div>
          );
        }

        return (
          <div style={style} className="lifter-details">
            {manualRecord}
            {recordsForAttempt?.map((record, index) => {
              if (index >= maxRecordsToShow) {
                return null;
              }

              const recordText = formatLongEligibleRecord({
                record,
              });

              return <div key={recordText}>RECORD: {recordText}</div>;
            })}
          </div>
        );
      }}
    </DisplayComponent>
  );
};

export default RecordInfo;
